import { NumberFormatValues } from 'react-number-format';
import { useCallback } from 'react';
import {
  useRfqBuilderActions,
  useRfqBuilderFutureLegView,
  useRfqBuilderView,
} from '@paradigm/features/src/unified-rfqs/ui';

import { useSubmitted } from '@paradigm/features/src/forms/submitted-context';
import { useDebouncedTrackAction } from '@paradigm/features/src/analytics';
import { BaseNumericField } from './BaseNumericField';

export default function PriceField() {
  const { index, price, isHedge } = useRfqBuilderFutureLegView();
  const { strategy, strategyShortcut } = useRfqBuilderView();
  const { changeLegPrice } = useRfqBuilderActions();
  const { didSubmit } = useSubmitted();
  const trackAction = useDebouncedTrackAction();

  const strategyCode =
    strategyShortcut.selectedOption?.value ??
    strategy.selectedOption?.value ??
    null;

  const handleOnChange = useCallback(
    ({ value }: NumberFormatValues) => {
      trackAction('update strategy leg', {
        strategyCode,
        price: value,
        isHedge,
      });
      if (value !== price.value) {
        changeLegPrice(index, value);
      }
    },
    [changeLegPrice, index, isHedge, price.value, strategyCode, trackAction],
  );

  if (!price.isSupported)
    throw new TypeError(
      'This component can only be used when price is supported.' +
        ' Make sure this leg is a hedge leg.',
    );

  return (
    <BaseNumericField
      placeholder="Enter"
      aria-label="Leg price"
      value={price.value}
      decimalScale={price.precision}
      onValueChange={handleOnChange}
      warning={!price.isValid && didSubmit}
    />
  );
}
